/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Ownershipverification2Inputs */

const id_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi kepemilikan`)
};

const ms_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengesahan pemilikan`)
};

const da_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejerskabsbekræftelse`)
};

const de_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besitzbestätigung`)
};

const en_us2_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership verification`)
};

const es_es2_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación de propiedad`)
};

const es_mx2_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación de propiedad`)
};

const fil_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagpapatunay ng pagmamay-ari`)
};

const fr_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification de propriété`)
};

const it_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica di proprietà`)
};

const hu_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulajdonjog ellenőrzése`)
};

const nl_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigendomsverificatie`)
};

const no_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eierbekreftelse`)
};

const pl_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weryfikacja własności`)
};

const pt_br2_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificação de propriedade`)
};

const pt_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificação de propriedade`)
};

const ro_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificare proprietate`)
};

const fi_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omistuksen vahvistus`)
};

const sv_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ägarverifiering`)
};

const vi_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác minh quyền sở hữu`)
};

const tr_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahiplik doğrulaması`)
};

const cs_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověření vlastnictví`)
};

const bg_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка на собствеността`)
};

const ru_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтверждение владения`)
};

const uk_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтвердження власності`)
};

const ar_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحقق من الملكية`)
};

const hi_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वामित्व सत्यापन`)
};

const th_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การยืนยันความเป็นเจ้าของ`)
};

const ja_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有権確認`)
};

const zh_cn2_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拥有权验证`)
};

const zh_hant1_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`擁有權驗證`)
};

const ko_offerdetail_reviews_ownershipverification2 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverification2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소유권 인증`)
};

/**
* | output |
* | --- |
* | "Ownership verification" |
*
* @param {Offerdetail_Reviews_Ownershipverification2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_ownershipverification2 = /** @type {((inputs?: Offerdetail_Reviews_Ownershipverification2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Ownershipverification2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "da") return da_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "de") return de_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "it") return it_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "no") return no_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "th") return th_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_ownershipverification2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_ownershipverification2(inputs)
	return ko_offerdetail_reviews_ownershipverification2(inputs)
});
export { offerdetail_reviews_ownershipverification2 as "offerDetail.reviews.ownershipVerification" }